import type { TeamAssignment, TeamAssignmentData, TeamStats } from './types';

function teamStats(team: TeamAssignment[]): TeamStats {
  const sum = (f: (p: TeamAssignment) => number) => team.reduce((acc, p) => acc + f(p), 0);
  const overall = (p: TeamAssignment) =>
    ((p.attack_rating ?? 0) + (p.defense_rating ?? 0) + (p.game_iq_rating ?? 0) + (p.gk_rating ?? 0)) / 4;

  return {
    avgAttack: sum((p) => p.attack_rating ?? 0) / team.length,
    avgDefense: sum((p) => p.defense_rating ?? 0) / team.length,
    avgGameIq: sum((p) => p.game_iq_rating ?? 0) / team.length,
    avgGk: sum((p) => p.gk_rating ?? 0) / team.length,
    totalAttack: sum((p) => p.attack_rating ?? 0),
    totalDefense: sum((p) => p.defense_rating ?? 0),
    totalGameIq: sum((p) => p.game_iq_rating ?? 0),
    totalGk: sum((p) => p.gk_rating ?? 0),
    playerCount: team.length,
    avgRating: sum(overall) / team.length,
    totalRating: sum(overall),
  };
}

/**
 * The `balanced_team_assignments.team_assignments` payload. Shared by the admin
 * page's Save and the automatic brute-force balance so both store the same shape.
 */
export function buildTeamAssignmentData(assignments: TeamAssignment[]): TeamAssignmentData {
  const now = new Date().toISOString();
  return {
    teams: assignments,
    stats: {
      blue: teamStats(assignments.filter((p) => p.team === 'blue')),
      orange: teamStats(assignments.filter((p) => p.team === 'orange')),
    },
    selection_metadata: {
      startTime: now,
      endTime: now,
      meritSlots: 0,
      randomSlots: 0,
      selectionNotes: [],
    },
  };
}
